import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=320c50b4&scoped=true"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=320c50b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c50b4",
  null
  
)

export default component.exports